// 菜单 侧边栏
export default [{
		path: '/index',
		title: '首页',
		icon: 'home'
	},
	// {
	// 	title: '系统管理',
	// 	icon: 'folder-o',
	// 	children: [{
	// 		title: '账号管理',
	// 		path: '/AccountManagement'
	// 	}, {
	// 		title: '权限管理',
	// 		path: '/AuthorityManagement'
	// 	}]
	// },
	// {
	// 	title: '人事管理',
	// 	icon: 'folder-o',
	// 	children: [
	// 	// 	{
	// 	// 	title: '管理员',
	// 	// 	path: '/Manager'
	// 	// }, 
	// 	{
	// 		title: '业务员',
	// 		path: '/Salesman'
	// 	}]
	// },
	{
		title: '智能人事',
		icon: 'folder-o',
		children: [
			{
			title: '审批',
			path: '/ExaminationApproval'
		},
		{
			title: '请假类型',
			path: '/Absence'
		},
		// {
		// 	title: '考勤设置',
		// 	path: '/AttendanceSet'
		// }, 
		{
			title: '拜访路线',
			path: '/VisitRoute'
		},
		]
	},
	{
		title: '客户管理',
		icon: 'folder-o',
		children: [{
			title: '客户信息管理',
			path: '/CustomerManagement'
		}, 
		// {
		// 	title: '设备管理',
		// 	path: '/EquipmentManagement'
		// },
		]
	},
	{
		title: '下单开单',
		icon: 'folder-o',
		path: '/PurchaseOrder',
	},
	{
		title: '分配账号',
		icon: 'folder-o',
		path: '/AssignAccountNumber',
	},
	{
		title: '邀请码',
		icon: 'folder-o',
		path: '/InvitationCode',
	},
	{
		title: '产品管理',
		icon: 'folder-o',
		children: [{
			title: '普通产品',
			path: '/Productentry'
		}, {
			title: '活动产品',
			path: '/EventProducts'
		}]
	},
	{
		title: '销量预测',
		icon: 'folder-o',
		path: '/BookingManagement'
	},
	{
		title: '信息管理',
		icon: 'folder-o',
		children: [{
			title: '信息发布',
			path: '/InformationDelivery'
		}]
	},
	{
		title: '提成统计',
		icon: 'folder-o',
		path: '/ProfitCount',
	},
	{
		title: '文件管理',
		icon: 'folder-o',
		path: '/fileManagement'
	},
	{
		title: '文件夹管理',
		icon: 'folder-o',
		path: '/folderManagement'
	},
	{
		title: '公司详情',
		icon: 'folder-o',
		path: '/Companydetails'
	},
	{
		title: '相关协议',
		icon: 'folder-o',
		path: '/agreement'
	},
	
	// {
	// 	title: '组件',
	// 	icon: 'folder-o',
	// 	path: '/assembly'
	// },
]
